<template>
    <div>
        <div class="container-pdf">
            <div class="row">
                <div class="col-xs-12 col-lg-12">
                    <VueHtml2pdf
                        :show-layout="controlValue.showLayout"
                        :float-layout="controlValue.floatLayout"
                        :enable-download="controlValue.enableDownload"
                        :preview-modal="controlValue.previewModal"
                        :filename="controlValue.filename"
                        :paginate-elements-by-height="controlValue.paginateElementsByHeight"
                        :pdf-quality="controlValue.pdfQuality"
                        :pdf-format="controlValue.pdfFormat"
                        :pdf-orientation="controlValue.pdfOrientation"
                        :pdf-content-width="controlValue.pdfContentWidth"
                        :manual-pagination="controlValue.manualPagination"
                        :html-to-pdf-options="htmlToPdfOptions"

                        @progress="onProgress($event)"
                        ref="html2Pdf"
                    >
                        <ReportPdfContent 
                            :data="data" 
                            :fields="fields"
                            @domRendered="domRendered()" 
                            slot="pdf-content" 

                            ref="pdfContent"
                            @download="verifyDownload"
                        />
                    </VueHtml2pdf>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import ReportPdfContent from './ReportPdfContent.vue';

export default {
    name: "ReportViewPDF",

    components: {
        VueHtml2pdf,
        ReportPdfContent,
    },

    props: {
        data: {
            type: Object,
            require: true,
        },
        fields: {
            type: Object,
            require: true,
        },
    },

    data: function() {
        return {
            controlValue: {
                showLayout: true,
                floatLayout: false,
                enableDownload: true,
                previewModal: false,
                paginateElementsByHeight: 2480, //2480x3508
                manualPagination: true,
                filename: "teste",
                pdfQuality: 2,
                pdfFormat: "a4",
                pdfOrientation: "landscape", //portraitxlandscape
                pdfContentWidth: "auto",
                
            },
            contentRendered: false,
            progress: 0,
            generatingPdf: false,
            pdfDownloaded: false,
            ready: false
        }
    },

    computed: {
        htmlToPdfOptions: function() {
            return {
                margin: 1,
                filename: this.getFilename(),
                image: {
                    type: "jpeg",
                    quality: 0.95,
                },
                enableLinks: true,
                html2canvas: {
                    scale: this.controlValue.pdfQuality,
                    useCORS: true,
                },
                jsPDF: {
                    orientation: this.controlValue.pdfOrientation,
                    unit: "mm",
                    format: this.controlValue.pdfFormat,
                    putOnlyUsedFonts: false,
                    compress: true,
                    precision: 16,
                    userUnit: 1.0,
                    floatPrecision: "smart",
                },
            };
        },
    },
    
    methods: {
        getFilename: function() {
            let prefix = "relatorio_status_deliveryb2b_";
            let date = new Date();
            let sufix = ".pdf";
            return prefix + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "_" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "_" + date.getFullYear() + sufix;
        },

        domRendered: async function() {
            this.contentRendered = true;
            await this.$refs.html2Pdf.generatePdf();
            this.ready = true;
            this.$emit("generating", false);
        },

        /*validateControlValue: function() {
            if (this.controlValue.pdfQuality > 2) {
                alert("pdf-quality value should only be 0 - 2");
                this.controlValue.pdfQuality = 2;
                return false;
            }
            if (!this.controlValue.paginateElementsByHeight) {
                alert("paginate-elements-by-height value cannot be empty");
                this.controlValue.paginateElementsByHeight = 1400;
                return false;
            }
            const paperSizes = [
                "a0",
                "a1",
                "a2",
                "a3",
                "a4",
                "letter",
                "legal",
                "a5",
                "a6",
                "a7",
                "a8",
                "a9",
                "a10",
            ];
            if (!paperSizes.includes(this.controlValue.pdfFormat)) {
                alert(`pdf-format value should only be ${paperSizes}`);
                this.controlValue.pdfFormat = "a4";
                return false;
            }
            if (!this.controlValue.pdfOrientation) {
                alert("pdf-orientation value cannot be empty");
                this.controlValue.pdfOrientation = "portrait";
                return false;
            }
            if (!this.controlValue.pdfContentWidth) {
                alert("pdf-content-width value cannot be empty");
                this.controlValue.pdfContentWidth = "800px";
                return false;
            }
            return true;
        },*/
        
        onProgress: function(progress) {
            if (this.ready) {
                if (progress < 100) this.$emit("generating", true);
                else this.$emit("generating", false);
                this.progress = progress;
            }
            //console.log(`PDF generation progress: ${progress}%`);
        },
        
        /*beforeDownload: async function({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                    pdf.setTextColor(150);
                    pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3));
                } 
            }).save();
        },*/

        /*hasDownloaded: function(blobPdf) {
            this.pdfDownloaded = true;
            console.log(blobPdf);
        },*/

        download: function() {
            this.$refs.html2Pdf.generatePdf();
        },

        verifyDownload: function(value) {
            this.ready = value;
            this.$emit("generating", !value);
        }
    }
}
</script>

<style scoped>
.container-pdf {
    background-color: #fff;
}

.pdf-content {
    font-size: 10px;
}
</style>